<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import { getLocations, getLocationGroup } from "@/api/locations";
import KpiSummary from "@/view/components/consumer_insights/KpiSummary.vue";
import MetricsHeatmap from "@/view/components/consumer_insights/MetricsHeatmap.vue";
import swal from "sweetalert";
import { getAnalyticsDefault } from "@/api/analytics";
export default {
  name: "consumer-insights-analytics",
  components: {
    KpiSummary,
    MetricsHeatmap
  },
  data() {
    return {
      loading: false,
      tabIndex: 0,
      active_tab: 0,
      locations: [],
      location_groups: [],
      snackbar: false,
      text: "",
      timeout: 2000,
      hasLocations: false,
      hasLocationGroups: false,
      categoryOptions: [
        { name: "sales", value: "sales" },
        { name: "traffic", value: "traffic" },
        { name: "average check", value: "average_check" },
        { name: "frequency", value: "frequency" },
        { name: "recency", value: "recency" }
      ]
    };
  },
  watch: {
    $route: {
      immediate: true,
      handler(to, from) {
          document.title = to.meta.title || 'Aben';
      }
    }
  },
  async beforeMount() {
  },
  async mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [{ title: "Consumer Insights" }]);
    this.$store.commit("setLocationVisibile", false);
    const response = await getLocations();
    if (!response) {
      swal(
        "",
        "Something went wrong in fetching locations. Please try again later"
      );
    }
    const response_location_groups = await getLocationGroup();
    if (!response_location_groups) {
      swal(
        "",
        "Something went wrong in fetching location groups. Please try again later"
      );
    }
    if (response) {
      this.locations = response;
      this.$nextTick(() => {
        this.hasLocations = response && response.length > 0 ? true : false;
      })
    }
    if (response_location_groups) {
      this.location_groups = response_location_groups;
    }
  }
};
</script>

<style scoped>
.tabs /deep/ .tab-pane:focus {
  outline: none;
}
</style>

<template>
  <v-app class="bg-transparent">
    <v-main>
      <v-card class="content-box">
        <v-tabs
          v-model="active_tab"
          background-color="white"
          color="deep-purple accent-4"
          left
        >
          <v-tab @click="tabIndex = 0">Kpi Summary</v-tab>
          <v-tab @click="tabIndex = 1">Metrics Heatmap</v-tab>
          <v-tab-item :key="0">
            <v-container fluid>
              <kpi-summary
                v-if="hasLocations"
                :locations="locations"
                :location_groups="location_groups"
              ></kpi-summary>
            </v-container>
          </v-tab-item>
          <v-tab-item :key="1">
            <v-container fluid>
              <metrics-heatmap
                v-if="hasLocations"
                :locations="locations"
                :location_groups="location_groups"
              ></metrics-heatmap>
            </v-container>
          </v-tab-item>
        </v-tabs>
      </v-card>
    </v-main>
  </v-app>
</template>
